import { Directive, Output, TemplateRef } from '@angular/core';
import { EventEmitter, Input, ViewContainerRef } from "@angular/core";
import { ConnectionPositionPair, Overlay, OverlayConfig, OverlayRef } from "@angular/cdk/overlay";
import { TemplatePortal } from "@angular/cdk/portal";

@Directive({
  selector: '[libTimepicker]'
})
export class TimepickerDirective {
  private openStatus = false;
  @Input('originEl') originEl: any;
  @Output() statusEmitter = new EventEmitter<boolean>();

  @Input('openStatus')  set createOverlayOnInput(openStatus){
    this.openStatus = openStatus;
    if (this.originEl && this.openStatus) { this.createOverlay(this.originEl); }
  }
  private overlayRef!: OverlayRef;
  constructor(private templateRef: TemplateRef<Element>, private overlay: Overlay, private viewContainerRef: ViewContainerRef) {}

  createOverlay(origin: any): void {
    const positions = [
      new ConnectionPositionPair({ originX: "start", originY: "bottom" }, { overlayX: "start", overlayY: "top" }, 0, 4),
      new ConnectionPositionPair({ originX: "end", originY: "bottom" }, { overlayX: "end", overlayY: "top" }, 0, 4)
    ];

    const overlayConfig = new OverlayConfig({
      hasBackdrop: true,
      backdropClass: "cdk-overlay-transparent-backdrop",
      positionStrategy: this.overlay
        .position()
        // connecting the dropdown overlay to the input element
        .flexibleConnectedTo(origin)
        .withPositions([...positions])
        .withPush(true)
    });

    this.overlayRef = this.overlay.create(overlayConfig);
    const dropdownPortal = new TemplatePortal(this.templateRef, this.viewContainerRef);
    this.overlayRef.attach(dropdownPortal);
    this.overlayRef.backdropClick().subscribe(resp => {
      this.openStatus = false;
      this.statusEmitter.emit(false);
      this.overlayRef.detach();
    });
  }

  destroyOverlay(){
    this.overlayRef.detach();
  }

}
